import { ERROR_RESPONSES } from '../constants/serverResponses'

/**
 * Provides error text depends on error type (or HTTP error code)
 * @param {number} errorType
 * @returns {string}
 */
export const RESPONSE_ERROR_TEXT = (l10n, errorType = '') => {
  switch (errorType) {
    case ERROR_RESPONSES.USER_DETAILS_ERROR:
      return l10n.t('USER_DETAILS_ERROR')
    case ERROR_RESPONSES.USER_AUTH_ERROR:
      return l10n.t('USER_AUTH_ERROR')
    case ERROR_RESPONSES.TIMEOUT_ERROR:
      return l10n.t('TIMEOUT_ERROR')
    default:
      return l10n.t('TECHNICAL_DIFFICULTIES_ERROR')
  }
}
